import { get } from './http';

// Types sourced from https://github.com/ev-proddev/team
// Paths below are relative to that repo root (team-dto/src/main/java/com/experticity/team/dto/).

// ── Types ─────────────────────────────────────────────────────────────────────

/** @source TeamProductTaxonomyDTO.java */
export type TeamProductTaxonomy = {
  teamId: number;
  rank: number;
  productTaxonomyId: number;
  imageUrl: string;
  name: string;
  url: string;
};

/** @source TeamOrganizationDTO.java */
export type TeamOrganization = {
  teamId: number;
  orgId: number;
  rank: number;
  orgName: string;
  orgKey: string;
  communityPageUrl: string;
  orgImageUrl: string;
};

/** @source TeamCombinedDTO.java */
export type TeamCombined = {
  productTaxonomies: TeamProductTaxonomy[];
  organizationTaxonomies: TeamOrganization[];
};

/** @source TeamClassDTO.java */
export type TeamClass = {
  teamClassId: number;
  classCode: number;
  name: string;
  description: string;
  sortOrder: number;
};

// ── API ───────────────────────────────────────────────────────────────────────

export function getTeamClasses(): Promise<TeamClass[]> {
  return get<TeamClass[]>('/xapi/team/pub/1.0/teamClass');
}

export function getTeamFavorites(teamId: number): Promise<TeamCombined> {
  return get<TeamCombined>(`/xapi/team/ext/1.0/taxonomy/team/${teamId}`);
}
